import styled, { css } from 'vue-styled-components';
import { always } from 'ramda';

import { styleWhenTrue } from '../../utils/styling';
import { COLORS } from '../../colors';
import { device } from '../../utils/media';

export const Container = styled.div`
  display: inline-block;
  flex-grow: 1;
  position: relative;

  &:focus {
    outline: none;
  }
`;

export const Options = styled('div', { open: Boolean })`
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: absolute;
  z-index: 2;
  top: 100%;
  border: 2px solid ${COLORS.LIGHT_GRAY};
  border-top: none;
  background-color: ${COLORS.WHITE};
  width: 100%;
  max-height: 500px;
  overflow: auto;
  margin-top: -2px;
  box-sizing: border-box;
`;

const activeStyles = ({ active, isGlanceTable }) =>
  styleWhenTrue(
    always(css`
      background-color: ${({ theme }) => (isGlanceTable ? theme.dropdownColor : COLORS.LIGHT_GRAY)};
      pointer-events: none;
      cursor: default;
    `)
  )(active);

const multipleActiveStyles = styleWhenTrue(
  always(css`
    background-color: ${({ theme }) => theme.dropdownColor};
  `)
);

export const Option = styled('div', {
  active: Boolean,
  multipleActive: Boolean,
  isGlanceTable: { type: Boolean, default: false },
})`
  padding: 6px 30px 6px 15px;
  border-top: 2px solid ${COLORS.LIGHT_GRAY};
  text-transform: uppercase;
  background-color: ${COLORS.WHITE};
  cursor: pointer;
  display: block;
  color: ${COLORS.DARK_BLUE};
  font-size: 18px;
  line-height: 27px;

  ${({ active, isGlanceTable }) => activeStyles({ active, isGlanceTable })};
  ${({ multipleActive }) => multipleActiveStyles(multipleActive)};
`;

export const Title = styled.div`
  color: ${COLORS.GRAY};
  text-transform: uppercase;
  font-size: 0.8em;
  line-height: 27px;

  @media ${device.desktop} {
    font-size: 1em;
    margin-bottom: 5px;
  }
`;

const notLastStyles = styleWhenTrue(
  always(css`
    border-right: none;
  `)
);

export const SelectedOption = styled('div', { last: Boolean })`
  color: ${COLORS.DARK_BLUE};
  font-size: 14px;
  line-height: 27px;
  padding: 6px 15px;
  border: 2px solid ${COLORS.LIGHT_GRAY};
  text-transform: uppercase;
  cursor: pointer;

  @media ${device.desktop} {
    font-size: 18px;
    ${({ last }) => notLastStyles(!last)};
  }
`;
